import { accessRouteChain } from './access-route-chain.js';
import type { AccessRoute } from './route-access.js';

/** Every permission a route needs to open: its own `required` and its ancestors'. */
export function routeRequirements(route: AccessRoute): string[] {
  return [...new Set(accessRouteChain(route).flatMap((entry) => entry.required ?? []))];
}
